import { propertiesTypes, commonTypes } from '@/reports/types';
import { getDatesSeen, formatPhone, nameize } from '@/utils/index';
import { PersonSearchParams } from '../useSearchPerson/useSearchPerson';

const aliasText = (names: commonTypes.Names) => {
  const otherNames = names.slice(1);
  const aliases = otherNames.map((alias) => {
    return nameize(alias.full);
  });
  return aliases.join(', ');
};

export const mapResidentsToResidentInfo = (
  residents: propertiesTypes.Residents,
  isInPartialAddressesVariation?: boolean
): propertiesTypes.ResidentInfo[] => {
  return residents.map(
    (
      resident: propertiesTypes.Residents[number]
    ): propertiesTypes.ResidentInfo => {
      const residentNames = resident?.names;
      const aliases = aliasText(residentNames);
      const age = resident?.dobs?.[0]?.age || '-';
      const bvId = resident?.id || '';
      const phoneNumber = resident?.phones[0]?.number || '';

      const dataListItems = [
        ['May also go by', aliases],
        ['Age', `${age}`],
        ['Phone', phoneNumber ? formatPhone(phoneNumber) : '-'],
        ['Dates Seen', getDatesSeen(resident?.addresses?.[0]) || '-'],
      ];
      const fullName = nameize(residentNames[0]?.full) || '';
      const personSearch: PersonSearchParams = {
        fName: residentNames[0]?.parsed?.first || '',
        mName: residentNames[0]?.parsed?.middle || '',
        lName: residentNames[0]?.parsed?.last || '',
        age: String(age) || '',
        city: resident?.addresses?.[0]?.parsed?.city || '',
        state: resident?.addresses?.[0]?.parsed?.state || '',
        showPartialAddresses: !!isInPartialAddressesVariation,
      };

      return { fullName, dataListItems, personSearch, bvId };
    }
  );
};
